<template>
  <div class="listBox">
    <a-list :grid="{ gutter: 16, column: 4 }">
      <a-list-item class="gutter-box">
        <a><button class="TopListbtn" style="background:#e6ae57;">
          <a-icon type="snippets" /><span>百姓信息发布</span>
        </button></a>
      </a-list-item>
      <a-list-item class="gutter-box">
        <a><button class="TopListbtn" style="background:#d29e4b;">
          <a-icon type="container" /><span>产权交易平台</span>
        </button></a>
      </a-list-item>
      <a-list-item class="gutter-box">
        <a><button class="TopListbtn" style="background:#be8b38;">
          <a-icon type="video-camera" /><span>电商推广平台</span>
        </button></a>
      </a-list-item>
      <a-list-item class="gutter-box">
        <a><button class="TopListbtn" style="background:#a9753c;">
          <a-icon type="audit" /><span>工作管理平台</span>
        </button></a>
      </a-list-item>
    </a-list>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style scoped>
  .listBox{
    height:120px;
  }
  .TopListbtn {
    height: 100px;
    width: 100%;
    font-size: 26px;
    font-weight: 800;
    font-family: Arial, Helvetica, sans-serif;
  }
  .gutter-box {
    padding:  0 10px 0 0;
  }
  .listBox :last-child{
    padding-right: 0px;
  }
</style>
